import { PageModuleType } from '@/types/module.types';
import { Session } from '@/types/session.types';
import { LanguagesAbbr } from '@/types/translation.types';
import convertHtmlString from '@/utils/convert-html-string';

export const sessionNameAndDescription = (
  session: Session,
  language: LanguagesAbbr
): { name: string; description: string } => {
  const descriptionModule = session.modules.find((module) => module.type === PageModuleType.description);
  const name = descriptionModule?.content?.title?.[language] ?? descriptionModule?.content?.title?.base ?? '';
  const description =
    descriptionModule?.content?.description?.[language] ?? descriptionModule?.content?.description?.base ?? '';

  return { name: convertHtmlString(name), description: convertHtmlString(description) };
};
